import { Syncable } from "shared/state/models/syncable";
import { IWorkListToTreatmentPlan } from "shared/api/api";


export const SAVE_WORK_LIST_TO_TREATMENT_PLAN = 'SAVE_WORK_LIST_TO_TREATMENT_PLAN';
export const SYNC_WORK_LIST_TO_TREATMENT_PLAN = 'SYNC_WORK_LIST_TO_TREATMENT_PLAN';
export interface WorkListToTreatmentPlanState extends Syncable<IWorkListToTreatmentPlan> {}
